import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold mt-5 mb-2" }, "Información del movimiento", -1)
const _hoisted_3 = { class: "flex flex-col gap-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "flex text-sm font-semibold",
  for: "date"
}, "Fecha", -1)
const _hoisted_5 = { class: "flex lg:flex-row flex-col gap-2" }
const _hoisted_6 = ["disabled"]

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { ShareholderService } from "@/services/shareholder/ShareholderService";
import { MovementService } from "@/services/movements/MovementService";
import { shareMovementStore } from "@/stores/movements";
import { useShareholderStore } from "@/stores/shareholder";
import {
  ShareholderBaseMovement,
  MovementOptionTypes,
  OperationOptionTypes,
} from "@/services/movements/types";
import { ShareholderResume } from "@/services/shareholder/types";
import InPlaceMessage from "./InPlaceMessage.vue";

import Datepicker from "@vuepic/vue-datepicker";
import Swal from "sweetalert2";

import AppSpinner from "@/components/atoms/AppSpinner.vue";

import NewModal from "@/components/atoms/NewModal.vue";
import TextField from "@/components/atoms/TextField.vue";
import Selector from "@/components/atoms/Selector.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewMovementModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;





const forceRegister = ref<boolean>(false);
const dateWarningError = ref<string>(
  "El accionista aún no puede vender todas sus acciones"
);
const shareholderService = new ShareholderService();

const movementService = new MovementService();
const shareholders = ref<ShareholderResume[]>([]);
const shareholderItems = computed(() => {
  let shareholderAux = shareholders.value
    .filter((shareholder) => shareholder.id != shareholderId.value)
    .map((shareholder) => {
      let AStringLabel = shareholder.investorNumberA
        ? " A  [" + shareholder.investorNumberA + "] -  "
        : "";
      let BStringLabel = shareholder?.investorNumberB
        ? " B  [" + shareholder?.investorNumberB + "] - "
        : "";
      return AStringLabel + BStringLabel + shareholder.identificationName;
    });
  return ["Dhelos", ...shareholderAux];
});
const shareholderValues = computed(() => {
  let shareholderAux = shareholders.value
    .filter((shareholder) => shareholder.id != shareholderId.value)
    .map((shareholder) => shareholder.id);
  return [-1, ...shareholderAux];
});

const shareholderStore = useShareholderStore();
const movementsStore = shareMovementStore();
const router = useRouter();
const shareholderId = computed(() =>
  Number(router.currentRoute.value.params.id)
);
const loading = ref(false);
const hasError = ref(false);
const errorMessage = ref("");

const movementOptionSelected = ref<MovementOptionTypes>(
  MovementOptionTypes.ACTION_B
);
const shareholderSelected = ref<number>(-1);
const operationOptionSelected = ref<OperationOptionTypes>(
  OperationOptionTypes.BUY
);
const movementInstance = ref<ShareholderBaseMovement>(
  new ShareholderBaseMovement()
);
const date = ref(new Date());
const amount = ref<number | undefined>(undefined);

async function getShareholders() {
  const response = await shareholderService.getShareholders();
  if (!response.success) {
    shareholders.value = [];
    return;
  }
  shareholders.value = response.data;
}

/**
 * Comprueba si el valor ingresado como parámetro es nulo o no definido.
 * @param value Valor a comprobar
 */
function isNullOrEmpty(value?: string | number | null): boolean {
  return !value || value == null || value == "" || value == 0;
}

// Indica si el formulario tiene algun error de dato o valor requerido
const formHasError = computed(() => {
  const requiredFields = [movementOptionSelected.value, amount.value];

  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }

  // Listao de posibles errores del formulario de registro
  const formErrors = [typeActionFieldHasError.value, amountFieldHasError.value];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }

  return false;
});

const typeActionFieldHasError = computed(() => {
  return isNullOrEmpty(movementOptionSelected.value);
});

const amountFieldHasError = computed(() => {
  return isNullOrEmpty(amount.value);
});

async function submitNewMovement() {
  if (date.value) {
    movementInstance.value.createdAt = new Date(date.value).toISOString();
  }
  errorMessage.value = "";
  let destinatioShareholder = undefined;
  movementInstance.value.groupAAmount = undefined;
  movementInstance.value.groupBAmount = undefined;
  movementInstance.value.forceUpdate = forceRegister.value;
  shareholderSelected.value < 0
    ? (destinatioShareholder = undefined)
    : (destinatioShareholder = shareholderSelected.value);
  movementOptionSelected.value == MovementOptionTypes.ACTION_A
    ? (movementInstance.value.groupAAmount = amount.value)
    : (movementInstance.value.groupBAmount = amount.value);
  operationOptionSelected.value == OperationOptionTypes.BUY
    ? ((movementInstance.value.buyerUserId = shareholderId.value),
      (movementInstance.value.sellerUserId = destinatioShareholder))
    : ((movementInstance.value.sellerUserId = shareholderId.value),
      (movementInstance.value.buyerUserId = destinatioShareholder));

  loading.value = true;
  const response = await movementService.registerMovements(
    movementInstance.value
  );
  loading.value = false;

  if (!response.success) {
    errorMessage.value = (response.data as any)["detail"];
    if (errorMessage.value == dateWarningError.value) {
      forceRegister.value = true;
      Swal.fire(
        "¡Error!",
        "Algo salió mal, vuelva a recargar la página.",
        "error"
      );
    }
    return;
  }
  Swal.fire(
    "¡Listo!",
    "Solicitud de Movimiento  realizada con éxito",
    "success"
  );
  movementsStore.query(shareholderId.value);
  shareholderStore.query(shareholderId.value);
  movementOptionSelected.value = MovementOptionTypes.ACTION_B;
  amount.value = undefined;
  movementInstance.value.groupAAmount = undefined;
  movementInstance.value.groupBAmount = undefined;
  movementInstance.value.createdAt = undefined;
  movementInstance.value.forceUpdate = false;
  forceRegister.value = false;
  emit("update:visible", false);
}

onMounted(() => {
  getShareholders();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NewModal, {
      title: "Registro de nuevo movimiento",
      visible: __props.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(Datepicker), {
            id: "date",
            "enable-time-picker": false,
            teleport: true,
            format: "dd/MM/yyyy",
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
            cancelText: 'Cancelar',
            selectText: 'Seleccionar'
          }, null, 8, ["modelValue"]),
          _createVNode(Selector, {
            label: "Asociar accionista",
            class: "w-full",
            model: shareholderSelected.value,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((shareholderSelected).value = $event)),
            "has-error": typeActionFieldHasError.value,
            "error-message": "Es necesario indicar el Tipo de movimiento",
            items: shareholderItems.value,
            values: shareholderValues.value
          }, null, 8, ["model", "has-error", "items", "values"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Selector, {
              label: "Tipo de acción",
              class: "w-full",
              model: movementOptionSelected.value,
              "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((movementOptionSelected).value = $event)),
              "has-error": typeActionFieldHasError.value,
              "error-message": "Es necesario indicar el Tipo de movimiento",
              items: [
                _unref(MovementOptionTypes).ACTION_A,
                _unref(MovementOptionTypes).ACTION_B,
              ]
            }, null, 8, ["model", "has-error", "items"]),
            _createVNode(Selector, {
              label: "Tipo de movimiento",
              class: "w-full",
              model: operationOptionSelected.value,
              "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((operationOptionSelected).value = $event)),
              "has-error": typeActionFieldHasError.value,
              "error-message": "Es necesario indicar el Tipo de movimiento",
              items: [_unref(OperationOptionTypes).BUY, _unref(OperationOptionTypes).SELL]
            }, null, 8, ["model", "has-error", "items"])
          ]),
          _createVNode(TextField, {
            model: amount.value,
            "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((amount).value = $event)),
            "has-error": amountFieldHasError.value,
            "error-message": "Es necesario indicarel monto del movimiento",
            type: "number",
            name: "amount",
            label: 'Monto de ' + movementOptionSelected.value.toLowerCase(),
            "hide-details": ""
          }, null, 8, ["model", "has-error", "label"]),
          (loading.value)
            ? (_openBlock(), _createBlock(AppSpinner, {
                key: 0,
                "no-text": ""
              }))
            : _createCommentVNode("", true),
          (errorMessage.value)
            ? (_openBlock(), _createBlock(InPlaceMessage, {
                key: 1,
                severity: "error",
                message: errorMessage.value
              }, null, 8, ["message"]))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass(["", 
            forceRegister.value
              ? 'bg-danger-color btn text-white ml-auto'
              : 'success btn ml-auto'
          ]),
          onClick: submitNewMovement,
          disabled: formHasError.value
        }, _toDisplayString(forceRegister.value ? "Forzar el registro" : "Registrar"), 11, _hoisted_6)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})